<template>
  <div class="animated fadeIn">
    <default-heading text="Add Grower" class="mt-3" />
    <div>
      <b-card v-for="(v_grower, index) in $v.customer_growers.$each.$iter" :key="index" class="mt-3">
        <CustomerGrowerFormGroup
          :vuelidate="v_grower"
          @onChange="onChangeGrower(index, $event)"
        />

        <div class="mb-3">
          <hr>

          <div v-for="(v_field, fieldIndex) in v_grower.fields.$each.$iter" :key="fieldIndex" class="d-flex align-items-start">
            <div class="flex-fill pr-2">
              <CustomerFieldFormGroup
                :label="`Field ${1 + +fieldIndex}`"
                :vuelidate="v_field"
                @onChange="onChangeField(index, fieldIndex, $event)"
              />
            </div>

            <b-button @click="removeField(index, fieldIndex)" variant="danger">
              <i class="fa fa-trash" />
            </b-button>
          </div>

          <b-row align-h="end">
            <b-col cols="2">
              <b-button variant="success" block @click="addField(index)">
                <i class="fa fa-plus" /> Add Field
              </b-button>
            </b-col>
          </b-row>
        </div>

        <div>
          <b-button variant="danger" @click="removeGrower(index)">
            <i class="fal fa-trash" />
          </b-button>
        </div>
      </b-card>

      <div class="d-flex my-4">
        <b-button variant="success" block @click="addGrower()">
          <i class="fa fa-plus" /> Add Grower
        </b-button>
      </div>

      <b-alert show v-if="error" variant="danger">{{ error }}</b-alert>

      <div class="clearfix mb-5">
        <b-button variant="success" class="float-right" :disabled="submittingForm" @click="save">
          <i v-if="submittingForm" class="fal fa-spinner fa-spin"></i>
          <span v-else>Save</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import CustomerGrowerFormGroup from '@/components/crm/customer/CustomerGrowerFormGroup'
import { validationMixin } from 'vuelidate/src'
import { required } from 'vuelidate/lib/validators'
import CustomerFieldFormGroup from '@/components/crm/customer/CustomerFieldFormGroup'
import CustomerGrowerModel from '@/models/crm/CustomerGrowerModel'
import CustomerFieldModel from '@/models/crm/CustomerFieldModel'

export default {
  name: 'CustomerGrowerAdd',
  components: {
    DefaultHeading,
    CustomerGrowerFormGroup,
    CustomerFieldFormGroup
  },
  mixins: [validationMixin],
  data () {
    return {
      customer_growers: [
        {
          name: '',
          fields: [
            {
              name: ''
            }
          ]
        },
      ],
      error: null,
      submittingForm: false
    }
  },
  validations: {
    customer_growers: {
      required,
      $each: {
        name: { required },
        fields: {
          $each: {
            name: { required }
          }
        }
      }
    }
  },
  methods: {
    addGrower () {
      this.customer_growers.push({
        name: '',
        fields: [
          {
            name: ''
          }
        ]
      })
    },

    removeGrower (index) {
      this.customer_growers.splice(index, 1)
    },

    addField (growerIndex) {
      this.customer_growers[growerIndex].fields.push({
        name: ''
      })
    },

    removeField(growerIndex, fieldIndex) {
      this.customer_growers[growerIndex].fields.splice(fieldIndex, 1)
    },

    onChangeGrower (index, grower) {
      this.customer_growers[index].name = grower.name
    },

    onChangeField (growerIndex, fieldIndex, field) {
      this.customer_growers[growerIndex].fields[fieldIndex].name = field.name
    },

    async save () {
      this.error = null
      this.submittingForm = true
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.submittingForm = false
        return
      }

      try {
        for (const grower of this.customer_growers) {
          const growerModel = new CustomerGrowerModel({
            ...grower,
            customer_id: this.$store.getters.getAuthCustomerID
          })

          const { response } = await growerModel.save()
          const customer_grower_id = response.data.id

          if (customer_grower_id) {
            // Save fields
            for (const field of grower.fields) {
              const fieldModel = new CustomerFieldModel({
                ...field,
                customer_id: this.$store.getters.getAuthCustomerID,
                customer_grower_id: customer_grower_id
              })
              await fieldModel.save()
            }
          } else {
            throw new Error('Error saving grower')
          }
        }

        this.$bvToast.toast('Thanks!', {
          title: 'Grower created successfully',
          variant: 'success',
          autoHideDelay: 1000
        })
        this.submittingForm = false
        this.$router.push('/customer-growers')
      } catch (err) {
        this.submittingForm = false
        if (err.response && err.response.response && err.response.response.data && err.response.response.data.message) {
          this.error = err.response.response.data.message
        } else {
          this.error = err.err || 'Something went wrong please contact an administrator'
        }
      }
    }
  }
}
</script>
